module.exports = __webpack_public_path__ + "static/img/jm-gw-logo3.8b73e3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jm/jm-gw-logo3.png
// module id = 4NGO
// module chunks = 13